import { FC, HTMLAttributes } from 'react';
import styles from './checkbox-tag.module.scss';
import classNames from 'classnames';

type Props = {
  label: string;
  className?: string;
} & HTMLAttributes<HTMLInputElement>;

const CheckboxTag: FC<Props> = ({ id, label, className, ...rest }: Props) => {
  return (
    <div className={classNames(styles['checkbox-tag'], className)}>
      <input type='checkbox' id={id} {...rest} />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default CheckboxTag;
